import { PropsWithChildren } from 'react';
import { Grid } from '@mui/material';

export const LoginLayout = ({ children }: PropsWithChildren) => {
  const styles = {
    loginBackground: {
      backgroundRepeat: 'no-repeat',
      backgroundColor: '#fff',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    loginShade: {
      backgroundColor: 'rgba(255,255,255,1)',
    },
  };

  return (
    <Grid container component="main" style={styles.loginBackground}>
      <Grid item xs={false} sm={2} md={3} lg={4} xl={4.25} />
      <Grid item xs={12} sm={8} md={6} lg={4} xl={3.5} style={styles.loginShade}>
        <Grid container sx={{ minHeight: '100vh' }} direction="column" justifyContent="center">
          <Grid item style={{ zIndex: 2 }}>
            {children}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={false} sm={2} lg={4} />
    </Grid>
  );
};
